import { FC, JSX } from 'react';

import { BaseSettings } from './BaseSettings';
import { RssSettings } from './RssSettings';

export interface ISettingsProps {}

export const Settings: FC<ISettingsProps> = (): JSX.Element => {
  return (
    <div className="flex !w-[348px] !min-w-[348px] !max-w-[348px] flex-col gap-4">
      <BaseSettings />
      <RssSettings />
    </div>
  );
};

export default Settings;
